export default __webpack_public_path__ + "static/media/realstate2.f968f75c.PNG";